export function prettyByte(byte: number): string {
  return `${byte < 0 ? "-" : ""}0x${Math.abs(byte)
    .toString(16)
    .padStart(2, "0")}`;
}
